module.exports = __webpack_public_path__ + "static/media/Houseplay.73b5c4cc.png";